import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderForm_Actor_Create_Mutation = graphql(`
  mutation FolderForm_Actor_Create(
    $actor: ActorUnionInput!
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    createFolderActor(
      actor: $actor
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useCreateFolderActorMutation = () =>
  useGraphQLMutation(FolderForm_Actor_Create_Mutation);
